import { handlerGetUrlParams } from '@/utils/dealUrlParams.js'
import request from '@/utils/request'

export function getFrontAchievementExhibition(data,param) {
  const url = handlerGetUrlParams('/bus/achievement/home/list', param)
  return request({
    url,
    method: 'POST',
    data
  })
}

export function getAchievementExhibition(data) {
  return request({
    url: '/bus/achievement/list',
    method: 'POST',
    data
  })
}

export function updateStatus(data) {
  return request({
    url: 'bus/achievement/batch_update_status',
    method: 'PUT',
    data
  })
}

export function deleteAchievementExhibition(params) {
  return request({
    url: `/bus/achievement/${params}`,
    method: 'DELETE'
  })
}

export function queryAchievementExhibition(id) {
  return request({
    url: `bus/achievement/info/${id}`,
    method: 'GET'
  })
}

export function addAchievementExhibition(data) {
  return request({
    url: `/bus/achievement`,
    method: 'POST',
    data
  })
}

export function updateAchievementExhibition(data) {
  return request({
    url: `/bus/achievement`,
    method: 'PUT',
    data
  })
}